import PropTypes from 'prop-types';
import React from "react";
import ReactDOMServer from "react-dom/server";
import * as rmd from 'material-ui';
import _ from "lodash";
import auth from '../auth';
import config from 'cfg';
import Promise from 'bluebird';
import getGoogleApiClient from 'google-client-api';

class WidgetStats extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            widget: {}
        };
    }

    componentDidMount () {
        this.loadData();
    }

    buildCharts = (wiid) => {

        return fetch(`${config.dash.api.host}/api/auth/google/token`)
            .then(response => response.json())
            .then(tokens => {
                gapi.analytics.auth.authorize({
                    'serverAuth': {
                        'access_token': tokens.access_token
                    }
                });

                var viewSelector = new gapi.analytics.ViewSelector({
                    container: 'view-selector'
                });
                viewSelector.execute();

                var dataChart = new gapi.analytics.googleCharts.DataChart({
                    query: {
                        metrics: 'ga:sessions, ga:pageviews, ga:users',
                        dimensions: 'ga:date',
                        filters: `ga:pagePath=@${wiid}`,
                        'start-date': '30daysAgo',
                        'end-date': 'yesterday'
                    },
                    chart: {
                        container: 'timeline',
                        type: 'LINE',
                        options: {
                            width: '100%'
                        }
                    }
                });
                viewSelector.on('change', function(ids) {
                    var newIds = {
                        query: {
                            ids: ids
                        }
                    }
                    dataChart.set(newIds).execute();
                });
            });
    }

    loadData() {
        var {user} = this.context;
        var widgetId = this.props.params.wiid;

        if (!user || !user.client) return null;

        return fetch(`${config.dash.api.host}/api/widgets/${widgetId}`)
            .then(response => response.json())
            .then(widget => {
                let wiid = widget.props && widget.props.wiid || widget._id || widgetId;
                this.setState({widget});
                return getGoogleApiClient().then((gapi) => {

                    gapi.load('analytics', () => this.buildCharts(wiid));
                });
            })
            .catch(err => {
                console.error(err);
                this.setState({error: err, isLoading: false});
            });

    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    }

    render () {
        var {user} = this.context;
        var {widget} = this.state;
        var wiid = widget && widget.props && widget.props.wiid;

        return (
            <div className="widget-stats">
                <rmd.Subheader>{wiid}</rmd.Subheader>
                <rmd.Subheader>{widget.widgetName}</rmd.Subheader>

                <div id="view-selector" style={{display: 'none'}}></div>
                <div id="timeline"></div>
            </div>
        )
    }
}

export default WidgetStats;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/WidgetStatsByWIID.js
 **/